import { Observable } from 'rxjs';
import { LgValidationResponse } from '../../model/library/validated-lg.model';

/**
 * Repository interface for LG validation operations
 * Used for validating LG codes when adding them to libraries
 */
export abstract class LgValidationRepository {
  /**
   * Validates an LG code for library assignment
   * Checks if the specimen with this LG code is in EXTRACTION_COMPLETED status
   *
   * @param lgCode The LG code to validate
   * @param technology Optional technology filter to validate multi-tech specimens
   * @returns Observable with validation response containing details if valid
   */
  abstract validateLg(
    lgCode: string,
    technology?: string
  ): Observable<LgValidationResponse>;
}
